export default "__VITE_ASSET__Bg9uq307__"